import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import Multiselect from "multiselect-react-dropdown";
import swal from "sweetalert";
import { get_ApiManager, post_ApiManager } from "../ApiManager/ApiManager";

function ClientPageHeader({ totalItem, onBranchChange }) {
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
    getAllowedBranches();
    getSelectedBranches();
  }, []);

  const getSelectedBranches = () => {
    get_ApiManager(
      "",
      "getSelectedBranches",
      (res) => setSelectedBranches(res.data.data),
      (err) => {
        throw err;
      },
    );
  };

  const getAllowedBranches = () => {
    get_ApiManager(
      "",
      "getAllowedBranches",
      (res) => setBranchList(res.data.data),
      (err) => {
        throw err;
      },
    );
  };

  const submitBranches = (branches) => {
    post_ApiManager(
      { branches },
      "saveBranches",
      (res) => {
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          getSelectedBranches();
          onBranchChange?.();
        }
      },
      (err) => {
        throw err;
      },
    );
  };

  const onRemove = (_selectedList, selectedItem) => submitBranches(selectedItem);
  const onSelect = (_selectedList, selectedItem) => submitBranches(selectedItem);

  const countLabel = totalItem
    ? `${Number(totalItem).toLocaleString()} client${totalItem === 1 ? "" : "s"} found`
    : "Manage all registered clients";

  const branchPlaceholder =
    selectedBranches.length > 0
      ? `${selectedBranches.length} branch${selectedBranches.length === 1 ? "" : "es"} selected`
      : "Select Branch/s";

  return (
    <div className="cms-page-header">
      <div className="cms-page-header-row">
        <div className="cms-page-header-title">
          <h1 className="m-0 text-2xl font-bold leading-tight text-slate-800">Clients</h1>
          <p className="mt-1.5 text-xs text-slate-500">{countLabel}</p>
        </div>

        <div className="cms-page-toolbar">
          <div className="cms-page-toolbar-branch">
            <label className="cms-page-toolbar-branch-label" htmlFor="client-branch-select">
              Branch
            </label>
            <div className="cms-page-toolbar-branch-input">
              <Multiselect
                id="client-branch-select"
                options={branchList
                  .slice()
                  .sort((a, b) => a.agencyname.localeCompare(b.agencyname))}
                className="cms-branch-ms chip-hide w-full"
                placeholder={branchPlaceholder}
                displayValue="agencyname"
                onSelect={onSelect}
                showCheckbox
                disablePreSelectedValues={false}
                hidePlaceholder={false}
                hideSelectedList
                onRemove={onRemove}
                selectedValues={selectedBranches}
              />
            </div>
          </div>

          <div className="cms-page-toolbar-actions">
          <Link
            to="/task-report"
            className="cms-page-toolbar-btn cms-page-toolbar-btn--secondary"
          >
            <FaIcons.FaRegCalendarAlt size={13} />
            <span>Progress Report</span>
          </Link>

          <Link
            to="/clients/add-client"
            className="cms-page-toolbar-btn cms-page-toolbar-btn--primary"
          >
            <FaIcons.FaPlus size={11} />
            <span>Add Client</span>
          </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientPageHeader;
